



























































































import { VbSnackbarService } from 'bag-of-holding-library';
import { Vue, Component } from 'vue-property-decorator';
import CostHelpType from '@/domain/cost-help-type/entity/cost-help-type.entity';
import CostHelpTypeService from '@/domain/cost-help-type/service/cost-help-type';
import CardTitle from '@/shared/card/card-title.component.vue';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import CurrencyField from '@/shared/currency-field.component.vue';
import ModalWarning from '@/shared/modal/modal-warning.component.vue';
import MobileHandler from '@/shared/utils/mobile-handler';
import Loading from '@/shared/loading/loading.component.vue';
import AuthorityStore from '@/domain/security/authority.store';
import AuthorityEnum from '@/domain/security/authority.enum';
import CostHelpTypeForm from './cost-help-type-form.component.vue';

@Component({
  components: {
    CardTitle,
    LabelSlot,
    CurrencyField,
    ModalWarning,
    CostHelpTypeForm,
    Loading,
  },
})
class CostHelpTypeView extends Vue {
  costHelpTypes: CostHelpType[] = [];

  loading: boolean = false;

  showInactive: number = 0;

  isMobile: boolean = MobileHandler.isLessThan(600);

  hasCreateNewCostHelpTypePermission: boolean = false;

  hasDeleteCostHelpTypePermission: boolean = false;

  hasUpdateCostHelpTypePermission: boolean = false;

  hasActivateCostHelpTypePermission: boolean = false;

  mounted() {
    this.loadAll();
    AuthorityStore.fetchedAuthority().then((authority) => {
      this.hasCreateNewCostHelpTypePermission = authority
        .hasAuthorities([AuthorityEnum.CREATE_COST_HELP_TYPE]);
      this.hasDeleteCostHelpTypePermission = authority
        .hasAuthorities([AuthorityEnum.DELETE_COST_HELP_TYPE]);
      this.hasUpdateCostHelpTypePermission = authority
        .hasAuthorities([AuthorityEnum.UPDATE_COST_HELP_TYPE]);
      this.hasActivateCostHelpTypePermission = authority
        .hasAuthorities([AuthorityEnum.ACTIVATE_COST_HELP_TYPE]);
    })
  }

  async loadAll(): Promise<void> {
    try {
      this.loading = true;
      const data = await CostHelpTypeService.getAll();
      this.costHelpTypes = data;
    } catch (error) {
      VbSnackbarService.handleHttpError(error);
    } finally {
      this.loading = false;
    }
  }

  handleAddNewCostHelpType(): void {
    const newCostHelpType = new CostHelpType({
      id: new Date().getTime().toString(),
      saved: false,
    });
    this.costHelpTypes.push(newCostHelpType);
  }

  handleDeleteLocalCostHelpType(costHelpType: CostHelpType): void {
    this.costHelpTypes = this.costHelpTypes.filter(cht => cht.id !== costHelpType.id);
  }

  onResize() {
    this.isMobile = MobileHandler.isLessThan(600);
  }

  get activeCostHelpTypes(): CostHelpType[] {
    return this.costHelpTypes.filter(cht => cht.active);
  }

  get inactiveCostHelpTypes(): CostHelpType[] {
    return this.costHelpTypes.filter(cht => !cht.active);
  }

  get showAddButton(): boolean {
    return !this.showInactive && this.hasCreateNewCostHelpTypePermission;
  }
}

export default CostHelpTypeView;
